<div class="dialog confirm-dialog">
  <button mat-button mat-dialog-close class="dialog__close" (click)="onClose()">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon><span>{{ 'shared.close' | translate }}</span>
  </button>
  <div mat-dialog-title>
    <h1>{{ 'shared.alert' | translate }}</h1>
  </div>

  <div mat-dialog-content class="confirm-container">
    <!-- VIEW MODE -->
    <div class="viewmode">
      <span><mat-icon class="mat-icon" svgIcon="alert-icon"></mat-icon></span>
      <span id="e2e-description">
        <span class="message">
          {{ 'shared.changesHaveBeenMadeReportGenerated' | translate }}
          {{ 'shared.clickButtonRefreshReportUsingUpdatedValues' | translate }}
          @if (context !== 'clipboard') {
          } @else {
            {{ 'shared.clipboardMessageOutDated' | translate }}
          }
        </span>
      </span>
    </div>
    <div mat-dialog-actions>
      <button class="btn-submit" (click)="onUpdate()">{{ 'shared.refresh' | translate }}</button>
    </div>
  </div>
</div>
